import { computed } from 'vue';

import { ShopDetails } from '~model';
import store from '~store';

export default function canRequestDonationReceipt(
  shop: ShopDetails,
): boolean {
  const getters = store?.getters;
  const voucherBalanceInCent = computed(() => getters?.getVoucherBalanceInCent);
  const voucherCategoryId = computed(() => getters?.getVoucherCategoryId);

  return (
    voucherCategoryId.value === 6 &&
    'donationReceipt' in shop &&
    'minimalDonationReceiptValue' in shop &&
    voucherBalanceInCent.value >= (shop?.minimalDonationReceiptValue || 0)
  );
}
